const roiSimulation = {
  pageName: 'סימולציית ROI',
  subtitle: 'השוו הרצה תפעולית בסיסית מול הרצה מותאמת של MoveAI, והמירו את ההפרשים לסיפור ROI.',
  controls: {
    title: 'בחרו הרצות להשוואה',
    grid: 'רשת',
    table: 'טבלה',
    filters: {
      baseline: {
        title: 'הרצת בסיס',
        description: 'שולף KPIs לתאריך שנבחר לפי זרימת העבודה הנוכחית של הלקוח.',
      },
      moveAI: {
        title: 'הרצת MoveAI',
        description: 'שולף KPIs להרצה המותאמת שנוצרה על ידי MoveAI עבור אותה פעילות.',
      },
      load: 'טעינה',
      loaded: 'נטען',
    },
  },
  barGraph: {
    title: 'הפרשים מרכזיים (בסיס מול MoveAI)',
    kpisSelected: 'KPIs נבחרו',
    selectKpis: 'בחרו KPIs להצגה',
    selected: 'נבחרו',
  },
  kpiComparisons: {
    title: 'השוואות KPI',
    resetKpis: 'איפוס KPIs',
    showDiffAs: 'הצג הבדל כ:',
    absolute: 'מוחלט',
    percentage: '%',
  },
  roiInputs: {
    title: 'קלטי ROI',
    reset: 'איפוס',
    perMonth: 'לחודש',
    tabs: {
      laborSavings: 'חיסכון בכוח אדם',
      supplierCosts: 'עלויות ספקים',
      feesHorizon: 'עמלות וטווח',
    },
    labor: {
      dispatchersToday: 'מוקדנים כיום',
      dispatchersTodayTooltip: 'מספר המוקדנים המועסקים כיום.',
      dispatchersWithMoveAI: 'מוקדנים עם MoveAI',
      dispatchersWithMoveAITooltip: 'מספר המוקדנים הנדרש המשוער לאחר MoveAI.',
      costPerDispatcher: 'עלות למוקדן',
      hoursPerDay: 'שעות ביום',
      workingDaysPerMonth: 'ימי עבודה בחודש',
      currency: 'מטבע',
      savingsTitle: 'חיסכון משוער במוקדנים (חודשי)',
      savingsDescription: 'מבוסס על הפחתת מוקדנים × עלות שעתית × שעות/יום × ימי עבודה/חודש.',
    },
    supplier: {
      costsToday: 'עלויות ספקים כיום (חודשי)',
      costsWithMoveAI: 'עלויות ספקים עם MoveAI (חודשי)',
      savingsTitle: 'חיסכון בספקים (חודשי)',
      savingsDescription: 'עלויות ספקים בסיסיות פחות עלויות ספקים של MoveAI.',
      totalSavingsTitle: 'חיסכון כולל (חודשי)',
      totalSavingsDescription: 'חיסכון בכוח אדם + חיסכון בספקים.',
    },
    fees: {
      paymentPlan: 'תוכנית תשלומים',
      roiHorizon: 'טווח ROI',
      platformMonthlyFee: 'עמלה חודשית של הפלטפורמה',
      oneTimeImplementationFee: 'עמלת הטמעה חד-פעמית',
      avgBookingsPerMonth: 'ממוצע הזמנות לחודש',
      platformBookingFee: 'עמלת הזמנה של הפלטפורמה',
      totalCostTitle: 'עלות כוללת (טווח)',
      totalCostDescription: 'הטמעה + (עמלות חודשיות × טווח).',
      paybackTitle: 'זמן החזר השקעה',
      paybackDescription: 'עלות כוללת / (חיסכון חודשי - עמלה חודשית).',
      roiTitle: 'ROI',
      roiDescription: 'תועלת נטו לאורך הטווח / עלות כוללת.',
      monthlyFee: 'עמלה חודשית',
      perBookingFee: 'עמלה להזמנה',
    },
    executiveSummary: {
      title: 'תקציר מנהלים',
      dispatcherSavings: 'חיסכון משוער במוקדנים (חודשי)',
      supplierSavings: 'חיסכון בספקים (חודשי)',
      totalSavings: 'חיסכון כולל (חודשי)',
      totalCost: 'עלות כוללת (טווח)',
      paybackTime: 'זמן החזר השקעה',
      roi: 'ROI',
    },
    suffix: {
      hrs: 'שע׳',
      days: 'ימים',
      day: 'יום',
      hr: '/שעה',
      months: 'חודשים',
    },
  },
  roiCardsContainer: {
    kpis: {
      totalReservations: 'סך הזמנות',
      assignedReservations: 'הזמנות שהוקצו',
      unassignedReservations: 'הזמנות שלא הוקצו',
      sharedRideReservations: 'הזמנות משותפות',
      totalTrips: 'סך נסיעות',
      assignedTrips: 'נסיעות שהוקצו',
      unassignedTrips: 'נסיעות שלא הוקצו',
      sharedRideTrips: 'נסיעות משותפות',
      driversWithShifts: 'נהגים עם משמרות',
      assignedDrivers: 'נהגים שהוקצו',
      avgTripsPerDriver: 'ממוצע נסיעות / נהג',
      avarageBookingsPerDriver: 'ממוצע הזמנות / נהג',
      averageTripsDistance: 'מרחק נסיעה ממוצע',
      averageTripsDuration: 'משך נסיעה ממוצע',
      averageDeadheadDistance: 'מרחק ריק ממוצע',
      averageIdleTime: 'זמן המתנה ממוצע',
      totalEarnings: 'סך הכנסות',
      earningPerHour: 'הכנסות לשעה',
      averageTripsEarnings: 'הכנסות ממוצעות לנסיעה',
      averageEarningsPerDriver: 'הכנסות ממוצעות / נהג',
      totalCost: 'עלות כוללת',
    },
    disabled: 'מושבת',
    baseline: 'בסיס',
    moveAI: 'MoveAI',
    noChange: 'ללא שינוי',
    kilometers: 'ק״מ',
    minutes: 'דק׳',
    currency: '$',
    k: 'k',
    plus: '+',
    minus: '-',
    percentage: '%',
  },
  tableView: {
    kpiName: 'שם KPI',
    diff: 'הפרש',
    exportTable: 'ייצוא טבלה',
    kpis: 'KPIs',
    exportedAt: 'הנתונים יוצאו בתאריך: {{date}}',
  },
  filters: {
    suppliers: {
      title: 'ספק:',
      placeholder: 'ספק',
    },
    attributes: {
      title: 'תכונה:',
      placeholder: 'תכונה',
    },
  },
};

export default roiSimulation;
